import { AbsoluteFill, useCurrentFrame } from "remotion";
import { COLORS, RULES, TIMEBAR_GRADIENT } from "./theme";
import { remainingFraction, remainingSeconds } from "./timebar-math";

/**
 * Per-slide multicolour time bar pinned to the TOP edge. Depletes left→right over
 * the current scene's duration. `sceneDurationFrames` MUST be passed (inside a
 * <Sequence>, useVideoConfig().durationInFrames is the whole composition, not the scene).
 */
export const SlideTimeBar: React.FC<{
  sceneDurationFrames: number;
  fps?: number;
  showReadout?: boolean;
}> = ({ sceneDurationFrames, fps = 30, showReadout = false }) => {
  const frame = useCurrentFrame();
  const frac = remainingFraction(frame, sceneDurationFrames);
  const secs = remainingSeconds(frame, sceneDurationFrames, fps);

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      {/* track */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: RULES.timeBarHeightPx,
          background: "#0A0D14",
        }}
      />
      {/* multicolour remaining fill */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: RULES.timeBarHeightPx,
          width: `${frac * 100}%`,
          background: TIMEBAR_GRADIENT,
          boxShadow: `0 0 14px -2px ${COLORS.cyan}`,
        }}
      >
        {/* bright playhead at the leading edge */}
        <div
          style={{
            position: "absolute",
            right: -1,
            top: -3,
            width: 2,
            height: RULES.timeBarHeightPx + 6,
            background: "#FFFFFF",
            boxShadow: "0 0 10px #FFFFFF",
          }}
        />
      </div>
      {showReadout && (
        <div
          style={{
            position: "absolute",
            top: 12,
            right: 18,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 13,
            letterSpacing: "0.14em",
            color: COLORS.dim,
          }}
        >
          {String(Math.floor(secs / 60)).padStart(2, "0")}:
          {String(secs % 60).padStart(2, "0")}
        </div>
      )}
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
